import styled from 'styled-components'
import { Flex } from 'rebass'
import { contentMaxWidth } from '../mixins'

const Content = styled(Flex).attrs({
  direction: 'column',
})`
  ${contentMaxWidth}
  margin-bottom: 20px;
  input[type='file'] {
    position: absolute;
    opacity: 0;
    z-index: -1;
    left: -999px;
  }
`

export default Content
